// 本文件包含comfy按钮、历史列表
import React, { Suspense, useCallback, useEffect, useRef, useState } from 'react';
import { Icon } from '@shakkerai/components';
import { createPortal } from 'react-dom';
import { Rnd } from 'react-rnd';
import { translate } from '@shakkerai/util-i18n';
import { commuityUrls } from '@starflow/app/constants/index';
import loadingImg from '@starflow/app/assets/loading.png';
import { config } from '@shakkerai/config';
import { request } from '@shakkerai/services';
import uniqid from 'uniqid';
import { setTempState, useProjectState, useTempState } from '@starflow/app/store';
import { convert2CompressedUrl } from '@shakkerai/util-image';
import styles from './referer.module.scss';
import { enterWorkflowMode } from '../helpers/helpers';
import { isOverseas } from '@shakkerai/pro-utils';
import WorkflowIcon from '../../../assets/seal-workflow-icon.svg';
import xingliuNewIcon from '../../../assets/new-xingliu-icon.svg';
import shakkerNewIcon from '../../../assets/new-shakker-icon.svg';
import cs from 'classnames';

const communityUrl = commuityUrls[config.name] || commuityUrls.prod;
const isOverseas = config.env === 'aws';

export const Entry = () => {
  const historyWorkflowShow = useTempState('historyWorkflowShow');
  const newUrl = isOverseas ? shakkerNewIcon : xingliuNewIcon;
  return (
    <>
      <button
        className="mr-[10px] relative"
        onClick={() => {
          setTempState(
            isOverseas
              ? {
                  historyWorkflowShow: true,
                }
              : {
                  exclusiveWindow: 'model-workflows',
                },
          );
        }}
      >
        {/* <Icon className="shk-gongzuoliu" fontSize={16} color="inherit" /> */}
        <img src={WorkflowIcon} className="w-[16px] h-[16px]" alt="" />
        <img src={newUrl} className="w-[26px] h-[13px] absolute max-w-[52px] -top-[11px] left-[8px]" alt="" />
      </button>
      {/* 历史工作流列表 */}
      {historyWorkflowShow && <WorkFlow />}
    </>
  );
};

// 最近使用工作流
const WorkFlowLink = () => {
  return (
    <button className="flex items-center" onClick={() => window.open('https://www.liblib.art/workflows', '__blank')}>
      <Icon className="shk-gongzuoliu text-sm text-primary" fontSize={16} />
      <span className="ml-[2px] translate-y-px text-xs text-primary underline">工作流广场</span>
    </button>
  );
};

const EmptyState = () => {
  return (
    <div className="min-h-[200px] flex justify-center flex-col">
      <span className="text-[#7f7f7f] text-sm mb-2 w-full text-center">{translate('flow_empty_tip1')}</span>
      {!isOverseas ? (
        <span className="flex text-[#7f7f7f] w-full justify-center">
          <span className="relative mr-1 top-[1px]">去浏览</span>
          {WorkFlowLink()}
        </span>
      ) : null}
    </div>
  );
};

const FlowContent = ({ data }) => {
  const currentElementTool = useProjectState('currentElementTool');
  const isInWorkflow = currentElementTool === 'workflow';

  return (
    <div>
      <div className="min-h-[200px] max-h-[360px] overflow-auto tiny-scrollbar p-4">
        <h2 className="text-xs font-semibold color-[#2d2d2d] mb-3">{translate('flow_empty_tip2')}</h2>
        {data.map((item, idx) => (
          <SingleFlow key={idx} data={item} isInWorkflow={isInWorkflow} />
        ))}
      </div>
      {!isOverseas ? (
        <div
          style={{ boxShadow: '-2px 0px 8px 0px rgba(0, 0, 0, 0.06)' }}
          className="h-[52px] flex justify-center items-center"
        >
          <span className="text-[#7F7F7F] font-normal text-xs mr-1">更多工作流 </span>
          {WorkFlowLink()}
        </div>
      ) : null}
    </div>
  );
};

let data = null;

const Content = () => {
  if (data === null) {
    // eslint-disable-next-line no-async-promise-executor
    const promise = new Promise(async (r) => {
      const res = await request('/gateway/sd-api/gen/tool/model/used/history', {
        modelType: '18',
        page: 1,
        pageSize: 100,
        requestId: uniqid(),
      });
      if (res.code === 0) {
        data = res.data.list;
        r();
      }
    });
    throw promise;
  }
  return <div className="">{!data.length ? <EmptyState /> : <FlowContent data={data} />}</div>;
};

function Spining() {
  return (
    <div className="flex items-center justify-center py-[118px] text-xs text-[#7f7f7f]">{translate('loading')}...</div>
  );
}

const WorkFlow = React.memo(() => {
  const pannelContainer = useRef();
  const firstRef = useRef(false);
  const handleClickOutside = useCallback((e) => {
    if (firstRef.current === false) {
      firstRef.current = true;
      return;
    }
    if (pannelContainer.current && pannelContainer.current.contains(e.target)) {
      return;
    } else {
      setTempState({
        historyWorkflowShow: false,
      });
    }
  }, []);
  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return createPortal(
    <Rnd default={{ x: 100, y: 100 }} scale={1} className={'z-[71]'} dragHandleClassName="sub-drag-handle">
      <div ref={pannelContainer} className="w-[300px] bg-white shadow-light rounded-sm">
        <div className="sub-drag-handle flex items-center justify-between px-[16px] py-[12px] cursor-move border-b border-b-[#EFEFEF]">
          {/* TODO starling */}
          <span className="text-[#2d2d2d] font-bold font-grotesk text-sm">{translate('flow_g_apply')}</span>
          <button
            onClick={() => {
              setTempState({
                historyWorkflowShow: false,
              });
            }}
          >
            <Icon fontSize={16} className="icon-border_close-1 text-[#2d2d2d]" />
          </button>
        </div>
        <Suspense fallback={<Spining />}>
          <Content />
        </Suspense>
      </div>
    </Rnd>,
    document.body,
  );
});

const SingleFlow = React.memo(({ data, isInWorkflow }) => {
  const { userName, userAvatar, name, modelUuid } = data;
  const [loading, setLoading] = useState();
  const enterWorkflowState = async (uuid) => {
    setLoading(true);
    try {
      const result = await request(`/api/www/img/tool/style/model/baseDetail/${uuid}`);
      if (result.code === 0) {
        enterWorkflowMode(result.data);
      }
    } catch (err) {
      console.log('api error', err);
    } finally {
      setLoading(false);
    }
  };

  const handleRunWorkflow = () => {
    if (isInWorkflow) return;

    enterWorkflowState(data.uuid);
  };

  return (
    <div className="flex justify-center items-center mb-3">
      <div className="flex-grow w-32 pr-3">
        <h2 className="color-[#2d2d2d] font-normal text-xs h-5 overflow-ellipsis overflow-hidden whitespace-nowrap">
          {name}
        </h2>
        <div className="flex items-center">
          <img src={convert2CompressedUrl(userAvatar, 40)} className="size-4 rounded-full" alt="" />
          <div className="w-44 ml-1 text-[#7f7f7f] text-xs font-normal overflow-ellipsis overflow-hidden whitespace-nowrap relative top-[1px]">
            {userName}
          </div>
        </div>
      </div>
      <div className={cs('w-11 flex items-center', isOverseas ? 'justify-end' : 'justify-between')}>
        {isOverseas ? null : (
          <i
            onClick={() => {
              window.open(`${communityUrl}${modelUuid}`, '__blank');
            }}
            fontSize="14"
            className="shakkerfont shk-xiangqing text-sm cursor-pointer text-[#414141]"
          ></i>
        )}
        {loading ? (
          <img className={`w-[14px] h-[14px] object-cover ${styles['animate-spin-ckpt']}`} src={loadingImg} alt="" />
        ) : (
          <button
            disabled={isInWorkflow}
            className="disabled:opacity-30 disabled:cursor-not-allowed"
            onClick={handleRunWorkflow}
          >
            <i fontSize="14" className="shakkerfont shk-danchuang-yunhangliang text-sm text-[#414141]" />
          </button>
        )}
      </div>
    </div>
  );
});
